var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-line"},[_c('img',{staticClass:"logo-el-login",attrs:{"src":require("../../assets/images/pages/login/logo_m.png"),"alt":""}}),_c('el-divider',{staticClass:"el-divider-el hidden-sm-and-up",attrs:{"color":"#000000","direction":"vertical"}}),_c('span',{staticClass:"logo-r-text mobile-title"},[_vm._v("\n    策略管理系统\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }